import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowLeft.svg",
  "use": "ArrowLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowLeft.svg\"><path d=\"M52.01,34.0209H16.8385L28.4256,45.5938a2.0016,2.0016,0,1,1-2.8324,2.8289L10.5707,33.4183a1.9982,1.9982,0,0,1,0-2.829L25.5932,15.5848a2.0017,2.0017,0,1,1,2.8324,2.8292L16.8046,30.0209H52.01a2,2,0,1,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol